// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3auC0","field":"styles_field__2RITJ","fieldCol":"styles_fieldCol__3hGs3","diffCol":"styles_diffCol__2Xhyv","diff":"styles_diff__3PzYH"};